/**
 * 입고작업 2.0(GL17) — 1.0 GL09 입고작업을 컨덕터 생성본(page.generated.tsx)으로 옮긴 화면(LOGISPRD-16037).
 * 1.0 GL09(iframe)는 그대로 두고 새 메뉴코드로 나란히 올린다.
 *
 * 화면은 생성본이 그리고, 상태·동작은 hooks/useInboundWork 가 쥔다. 이 엔트리는 훅 결과를 wiring.ts 슬롯에 묶기만 한다.
 */
import { useEffect, useRef } from 'react'
import InboundWorkV2Page from './page.generated'
import { useInboundWork } from './hooks/useInboundWork'
import { bindInboundWork } from './wiring'

export default function InboundWorkV2() {
  const controller = useInboundWork()
  // 슬롯은 생성본 렌더 중에 불린다 — 자식(생성본)보다 먼저 이 렌더의 값으로 묶는다.
  // 렌더 본문의 부수효과(모듈 변수 갱신)라 렌더 순수성을 어긴다. 동기 렌더에서는 같은 렌더의 자식이 바로 읽어 문제없지만,
  // 커밋 없이 버려지는 렌더(Suspense·동시성 기능)를 이 화면 위에 두면 버려진 렌더의 값이 남을 수 있다 — 그때는 배선을 컨텍스트로 바꾼다.
  bindInboundWork(controller)
  const controllerRef = useRef(controller)
  controllerRef.current = controller
  useEffect(() => {
    bindInboundWork(controllerRef.current)
    return () => bindInboundWork(null)
  }, [])
  return <InboundWorkV2Page />
}
